import React from "react";
import "./Accordion.scss";

const Accordion = props => {
  const { title, expand, onClick, section } = props;

  return (
    <div>
      <dt className={expand ? "title is-expanded" : "title"} onClick={onClick}>
        {title}
      </dt>
      <dd
        className={expand ? "content is-expanded" : "content"}
        onClick={onClick}
      >
        {section}
      </dd>
    </div>
  );
};

export default Accordion;
